import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

const ThreeDotsLoader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 220,
            }}
        >
            <Box sx={{ width: '60%' }}>
                <LinearProgress />
            </Box>
        </Box>
    );
};

export default ThreeDotsLoader;
